import { useState } from "react";

function BulletCard({ bullet, index }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(bullet);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bullet-card" style={{ animationDelay: `${index * 0.1}s` }}>
      <div className="bullet-index">{String(index + 1).padStart(2, "0")}</div>
      <p className="bullet-text">{bullet}</p>
      <button className={`btn-copy ${copied ? "copied" : ""}`} onClick={copy}>
        {copied ? "✓ Copied!" : "Copy"}
      </button>
    </div>
  );
}

export default function OutputPanel({ bullets, loading }) {
  const [copiedAll, setCopiedAll] = useState(false);

  const copyAll = async () => {
    const text = bullets.map((b, i) => `• ${b}`).join("\n");
    await navigator.clipboard.writeText(text);
    setCopiedAll(true);
    setTimeout(() => setCopiedAll(false), 2500);
  };

  return (
    <div className="panel output-panel">
      <div className="panel-header">
        <h2 className="panel-title">
          <span className="panel-num">02</span> Your Bullets
        </h2>
        {bullets.length > 0 && (
          <button className="btn-ghost" onClick={copyAll}>
            {copiedAll ? "✓ All Copied!" : "Copy All"}
          </button>
        )}
      </div>

      {loading && (
        <div className="output-loading">
          <div className="loading-bars">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="loading-bar" style={{ animationDelay: `${i * 0.15}s`, width: `${60 + Math.random() * 35}%` }} />
            ))}
          </div>
          <p className="loading-text">Crafting impact-driven bullets...</p>
        </div>
      )}

      {!loading && bullets.length === 0 && (
        <div className="output-empty">
          <div className="empty-icon">📝</div>
          <p>Your optimized resume bullets will appear here</p>
          <ul className="empty-features">
            <li>✦ Quantified achievements</li>
            <li>✦ Action-verb led sentences</li>
            <li>✦ ATS-friendly keywords</li>
            <li>✦ Copy-ready format</li>
          </ul>
        </div>
      )}

      {!loading && bullets.length > 0 && (
        <div className="bullets-list">
          <div className="bullets-meta">{bullets.length} bullets generated</div>
          {bullets.map((bullet, i) => (
            <BulletCard key={i} bullet={bullet} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
